
import {getReplenishmentUser} from '../api/getReplenishmentUser';
import {setGetReplenishmentUserAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetReplenishmentUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getReplenishmentUser(params);
            
            if (data.status === 'success') {
                const getArrayMap = (value) => {
                    
                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date)  {
                                tmp.push([{...value[i]}, {...value[i + 1]}])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }   
                    return tmp
                }

                const prev = getArrayMap(getState().usersMobile.user_replenishment.data)
                const replenishment = [];
                replenishment.push(prev);
                replenishment.push(getArrayMap(data.data));

                dispatch(setGetReplenishmentUserAction({
                    data: replenishment.flat(1),
                    countPage: data.count
                }));           
                dispatch(setLoadingAction(false))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishmentUser
}